import { Injectable } from '@angular/core';
import { EvsbThankYouMailMapper } from './evsb-thank-you-mail.mapper';
import { EvsbThankYouMailModel } from './evsb-thank-you-mail.model';

@Injectable()
export class EvsbThankYouMailService {
  constructor(private mapper: EvsbThankYouMailMapper) {}

  public getModel(): EvsbThankYouMailModel {
    return this.mapper.map();
  }
}
